import React from 'react'
import { Header, Footer } from '../components'

const DefaultLayout = ({children}) => {
  return (
    <React.Fragment>
      <Header />
      {children}
      <Footer />
    </React.Fragment>
  )
}

export { DefaultLayout }